import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { bulkSubmitPa } from "../../../../api/postCall/bulkSubmitPa";
import { ToastMessages } from "../../../../enums/toastMessages";
import { logError } from "../../../../utils/customLogger";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

export const onSave = async (
  uploadedFile: File | null,
  onSuccess: () => void,
): Promise<void> => {
  if (!uploadedFile) {
    toast.error(ToastMessages.CASE_INITIATION_NO_FILE);
    return;
  }

  const orgId = getOrgIdForFetchExternalWorklist();
  if (!orgId) {
    toast.error(ToastMessages.CASE_INITIATION_NO_ORG_ID);
    return;
  }

  try {
    await bulkSubmitPa({
      file: uploadedFile,
      org_id: orgId,
      max_rows: 500,
    });

    toast.success(ToastMessages.CASE_INITIATION_SUBMIT_SUCCESS);
    onSuccess();
  } catch (error) {
    logError(error as Error, "Error submitting bulk PA");
    toast.error(ToastMessages.CASE_INITIATION_SUBMIT_ERROR);
    onSuccess();
  }
};
